import axios from 'axios'

// Utilitários de sessão: detecção de token expirado, renovação via refresh
// token (rotação) e logout forçado. store/router são carregados sob demanda
// para evitar import circular (store -> services -> este arquivo).

export function isTokenExpired() {
    const token = localStorage.getItem('token');
    if (!token) return true;
    try {
        const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        // exp em segundos; margem de 30s para evitar requisição com token no limite
        return payload.exp ? (payload.exp * 1000) - 30000 <= Date.now() : false;
    } catch (error) {
        return true;
    }
}

// Renovação single-flight: várias chamadas simultâneas compartilham a mesma
// requisição de refresh (o token é de uso único — duas tentativas paralelas
// derrubariam a sessão por "reuso").
let refreshPromise = null;

export function refreshSession() {
    if (refreshPromise) return refreshPromise;

    const refreshToken = localStorage.getItem('refresh_token');
    if (!refreshToken) {
        const error = new Error('NO_REFRESH_TOKEN');
        error.sessionEnded = true;
        return Promise.reject(error);
    }

    refreshPromise = axios
        .post(`${process.env.VUE_APP_URL_SERVER}/api/admins/refresh`, { refreshToken })
        .then(({ data }) => {
            const store = require('@/store').default;
            store.commit('SET_SESSION', data);
            return data.token;
        })
        .catch((error) => {
            // 4xx do servidor = sessão realmente encerrada (expirada/revogada/reuso).
            // Erro de rede ou 5xx NÃO derruba a sessão — tenta de novo depois.
            if (error.response && error.response.status < 500) {
                error.sessionEnded = true;
            }
            throw error;
        })
        .finally(() => { refreshPromise = null; });

    return refreshPromise;
}

// Tenta renovar; se o servidor disser que a sessão acabou, desloga.
// Erros de rede/servidor propagam sem deslogar (modo "graça").
export async function refreshOrLogout() {
    try {
        return await refreshSession();
    } catch (error) {
        if (error.sessionEnded) handleSessionExpired();
        throw error;
    }
}

export function handleSessionExpired() {
    const store = require('@/store').default;
    const router = require('@/router').default;

    // Já deslogado (ex.: vários 401 simultâneos) — nada a fazer
    if (!localStorage.getItem('token') && !store.state.user.user) return;

    const currentPath = router.currentRoute.value.fullPath;
    if (currentPath && currentPath !== '/auth') {
        store.commit('SET_REDIRECT', currentPath);
    }

    store.commit('LOG_USER_OUT');
    store.commit('SET_ALERT', {
        heading: 'erro',
        message: 'Sua sessão expirou. Faça login novamente.'
    });
}
